declare global {
  var document: Document;
}

/**
 * This is a class that simplifies using JavaScript events.
 *
 * @class EventHandler
 * @constructor
 */
export class EventHandler {
    /**
     * Enabbles or disables debug output
     *
     * @property DEBUG
     * @type boolean
     * @default false
     */
    public DEBUG: boolean = false;

    /*
    initiatingObject is the object (class) that is utilizing this class. This
    is to pull needed data from object IE make reference communication
    available.
    bindObject is the DOM object to attach this event to.  document for global
    */
    constructor(public initiatingObject, public bindObject = document) {
        if ((typeof initiatingObject !== "undefined") && (typeof initiatingObject.debug !== "undefined")) {
            this.DEBUG = initiatingObject.debug;
        }
    }

    /**
     * dispatch method is for simplifying and unifying calling a custom event.
     * Method is accessible to outside via $sflyBridge.Binder().dispatch
     *
     * @method dispatch
     * @param {string} eventName  Event name to broadcast on.
     * @param {any} eventDataObbject Data object to be distributed with event.
     */
    public dispatch(eventName: string, eventDataObject: any): void {
        !!this.DEBUG && console.log(`Dispatched at ${eventName} with data ${eventDataObject}`);

        const evt = new CustomEvent(eventName, {
            bubbles: false,
            cancelable: false,
            detail: eventDataObject,
        });

        this.bindObject.dispatchEvent(evt);
    }

    /**
     * on is to provide a simple listener interface for the custom event.
     * A event with the propert REMOVE_LISTENERS in the data object will
     * remove the listener without ever being fired.
     *
     * @method on
     * @param {string} eventName - The name of the event to listen for.
     * @param {Function} cbHandler - Function to call when event is heard.
     * @param {boolean} justOnce - The callback should only be executed once and then the listener removed.
     * @returns void
     */
    public on(eventName: string, cbHandler: (eventData: any) => void, justOnce: boolean = false): void {
        const evtHandler = (eventObject: any = {}) => {
            if (justOnce || eventObject.detail.REMOVE_LISTENERS) {
                this.bindObject.removeEventListener(eventObject.type, evtHandler);
            }
            if (!eventObject.detail.REMOVE_LISTENERS) {
                cbHandler(eventObject.detail);
            }
        };

        if (this.initiatingObject && this.initiatingObject.handle) {
            !!this.DEBUG && console.log("listening at ", this.initiatingObject.handle + ":" + eventName);

            this.bindObject.addEventListener(
                this.initiatingObject.handle + ":" + eventName,
                evtHandler,
            );
        } else {
            !!this.DEBUG && console.log("listening at ", eventName);

            this.bindObject.addEventListener(
                eventName,
                evtHandler,
            );
        }
    }

}
